import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'rv-divider',
  template: `
    @if (!vertical()) {
      <span class="rv-divider__line" aria-hidden="true"></span>
      @if (isLabeled()) {
        <span class="rv-divider__label">{{ label() }}</span>
        <span class="rv-divider__line" aria-hidden="true"></span>
      }
    }
  `,
  styleUrl: './divider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'separator',
    '[attr.aria-orientation]': 'vertical() ? "vertical" : "horizontal"',
    '[attr.aria-label]': 'accessibleName()',
    '[class.rv-divider--labeled]': 'isLabeled()',
    '[class.rv-divider--vertical]': 'vertical()',
  },
})
export class RvDividerComponent {
  /** Centered label for the Figma “or” divider. Empty or unset renders a plain line. */
  label = input<string | null>(null);
  vertical = input(false, { transform: booleanAttribute });

  protected isLabeled = computed(() => {
    const value = this.label();
    return !!value && value.trim().length > 0 && !this.vertical();
  });

  protected accessibleName = computed(() => {
    const value = this.label();
    return this.isLabeled() && value ? value.trim() : null;
  });
}
